module.exports = __webpack_public_path__ + "img/green2.cce674b9.jpg";